import React from 'react';
import styled from 'styled-components';
import mediaQ from '../theme/responsive';
import InfoBox from './InfoBox';
import { Row, LabelCol, ContentCol } from '../theme/Grid';

export default ({ 
    children, 
    label, 
    hasInfoBox, 
    infoBoxContent, 
    infoBoxHeadline, 
    infoBoxPositioning 
    }) => (
    <GridRow>

        <Label>
        {label}
            {hasInfoBox ?  <InfoBox positioning={infoBoxPositioning} headline={infoBoxHeadline} content={infoBoxContent}  />    
         : null}
        </Label>
        <RowContent>{children}</RowContent>
    </GridRow>
);

const GridRow = styled(Row)`
    line-height:20px;
    margin-bottom: 15px;
    align-items: center;
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        flex-direction: row !important;
    }
    ${mediaQ.tablet`
        flex-direction: column;
        align-items: flex-start;
    `};
`;

const RowContent = styled(ContentCol)``;

const Label = styled(LabelCol)`
    ${mediaQ.tablet`
        margin-bottom: 15px;
        margin-top: 15px;
    `}
`;

